module.exports = __webpack_public_path__ + "img/worry-adviser.367bb4e.webp";